import styled from "styled-components";

export const Page = styled.div`
  
`;

const ProductsTableWrapper = styled.div`
`;

export default ProductsTableWrapper;